import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import {AuthService } from '../auth/auth.service';
import {environment} from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
  })
export class VisitorGuard implements CanActivate {
  modePro:boolean = false;

  constructor(private authService: AuthService) {
    this.modePro = environment.pro;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      console.log('VisitorGuard#canActivate called');
      // can pass only if user is not connected
      if ((this.authService.hasValidToken() && this.authService.getUser() && !this.authService.getUser().isPreAccount && !this.modePro) || (this.authService.hasValidToken() && this.modePro && this.authService.getUser() && !this.authService.UserHasNotOrganisationBis())) {
        this.authService.redirect(); // if connected redirect to defaultDestination
        return false;
      } else {
        console.log('VisitorGuard#canActivate true');
        return true;
      }
  }
}
